var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-height"},[_c('div',{staticClass:"centered"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"128"}})],1),_c('div',{staticClass:"spinner-label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }